<template>
  <div>
    <v-row v-if="!addressFormVisible" class="mb-2 address-search">
      <v-col>
        <component
          :is="findPropertyQuestion.AnswerControlType"
          :question="findPropertyQuestion"
          @togglePropertyDetailsCardVisible="setPropertyDetailsCardVisibility"
          @toggleAddressFormVisible="(value) => (addressFormVisible = value)"
          :isShowCardPropertyDetails="showPropertyDetailsCard"
        ></component>
      </v-col>
    </v-row>
    <template v-if="addressFormVisible">
      <div class="margin-address-form-lexis-nexis">
        <v-row
          v-for="(item, index) in otherAddressQuestions"
          :key="index"
          :class="['mt-0', isSelfServe ? '' : 'mb-2']"
        >
          <v-col>
            <component
              :is="item.AnswerControlType"
              :question="item"
              @togglePropertyDetailsCardVisible="
                setPropertyDetailsCardVisibility
              "
              @tryAgain="tryAgain"
            ></component>
          </v-col>
        </v-row>
      </div>
    </template>

    <v-btn
      color="#106175"
      depressed
      large
      rounded
      class="find-property-details font-20 font-weight-bold white--text"
      v-if="addressFormVisible"
      @click="handleFindPropertyDetails()"
      :loading="loading"
      aria-label="Find Property Details"
      >Find Property Details</v-btn
    >
    <!-- Property details card -->
    <v-row v-if="detailsCardVisible">
      <v-col class="col-12 col-lg-8">
        <LayoutPropertyDetailsCard
          :isD2C="question.IsD2C"
          :propertyDetails="propertyAnswersAsPropertyDetails"
          @emitEditButtonValue="setPropertyDetailsCardVisibility"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LayoutAddressMixin from "@/Mixins/LayoutAddressMixin";
import LexisNexisLookup from "@/Mixins/PropertyDetails/LexisNexisLookup";
import { setAddressFormVisibility } from "@/common/addresses";
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";
import InputBase from "@/components/Inputs/InputBase";
import InputFindPropertyLexisNexis from "@/components/Inputs/InputFindPropertyLexisNexis";
import LayoutPropertyDetailsCard from "@/components/LayoutComponents/LayoutPropertyDetailsCard";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapGetters, mapState } from "vuex";

export default {
  name: "LayoutAddressSearchLexisNexis",
  mixins: [LexisNexisLookup, LayoutAddressMixin],
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  components: {
    InputFindPropertyLexisNexis,
    InputBase,
    LayoutPropertyDetailsCard,
    HomeBaseLabel,
  },
  data() {
    return {
      addressFormVisible: false,
      showPropertyDetailsCard: false,
      loading: false,
    };
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, ["form", "lexisNexisResponse"]),
    ...mapGetters(QUESTIONS_MODULE, [
      "propertyDataRequiresEdit",
      "propertyAnswersAsPropertyDetails",
      "isSelfServe",
    ]),
    detailsCardVisible() {
      return !this.propertyDataRequiresEdit && this.showPropertyDetailsCard;
    },
    thirdPartyDataReceived() {
      return this.lexisNexisResponse !== null;
    },
  },
  methods: {
    handleFindPropertyDetails() {
      // manually set property details form visibility here since the propertyDetailsLookup method changes the
      // visibility too quickly
      // -> leading to no re-render of the form
      // -> not run mounted logic in the CounterBase
      // -> missing data when user does not touch the Bedrooms/Bathrooms question
      this.setPropertyDetailsFormVisibility(false);
      this.propertyDetailsLookup().then(() => {
        this.setPropertyDetailsCardVisibility(true);
      });
    },
    setPropertyDetailsCardVisibility(value) {
      this.showPropertyDetailsCard = value;
    },
    checkAndSetCardVisibility() {
      this.setPropertyDetailsCardVisibility(this.thirdPartyDataReceived);
    },
    tryAgain() {
      this.addressFormVisible = false;
      this.setPropertyDetailsFormVisibility(false);
    },
  },
  mounted() {
    this.checkAndSetCardVisibility();
    this.addressFormVisible = setAddressFormVisibility(
      this.findPropertyQuestion,
      this.otherAddressQuestions
    );
  },
};
</script>

<style lang="scss" scoped>
.margin-address-form-lexis-nexis {
  margin: -12px 0 0 0;
}

.find-property-details {
  margin-top: 18px;
  margin-bottom: 34px;
  width: 360px !important;
  height: 60px !important;
}
</style>
